import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {HEADER_MENU} from "@/components/constants/routes";
import {usePathname, useRouter} from "@/i18n/navigation";
import {IoMdClose} from "react-icons/io";
import {sideNavControl} from "@/redux/NavigationSlice";
import {SIZES} from "@/components/constants";
import {useLocale, useTranslations} from "next-intl";

const SideNav = () => {
    const pathName = usePathname();
    const router = useRouter();
    const dispatch = useDispatch();
    const sideNavState = useSelector((state) => state.navigation.sideNavState);
    const locale = useLocale();
    const langData = useSelector(state => state.language.data);
    const currentPath = pathName === `/${locale}` ? "/" : pathName.replace(`/${locale}`, "");
    const isActive = (item) => {
        let mark;
        if(!item.path) return;
        if(item.path === "/"){
            mark = currentPath === "/"
        } else {
            mark = currentPath.startsWith(item.path)
        }
        return mark;
    }

    return(
        <NaveWrap className={`${sideNavState ? "active" : ""}`}>
            <div className={"side-area"}>
            <div className={"close-inner"} onClick={() => {dispatch(sideNavControl(!sideNavState))}}><IoMdClose size={24}/></div>
            <ul className={"side-nav-wrap"}>
                {
                    langData &&
                    HEADER_MENU.filter((item) => item.active).map((item, idx) =>
                        <li key={idx}
                            className={`${isActive(item) ? "active" : ""}`}
                            onClick={() => {
                                if(!item.outside){
                                    router.push(item.path);
                                } else {
                                    window.open(item.path, "_blank", "noopener,noreferrer");
                                }
                                dispatch(sideNavControl(!sideNavState));
                            }}
                        >
                            <div dangerouslySetInnerHTML={{__html: langData[item.key]}}/>
                        </li>
                    )
                }
            </ul>
            </div>
        </NaveWrap>
    )
}
const NaveWrap = styled.div`
    display: none;
    .side-area{
        min-height: 100vh;
        padding: 32px;
        max-width: 300px;
        width: 100%;
        z-index: 10;
        position: fixed;
        top: 0;
        right: 0;
        background-color: #fff;
        box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        transform: translateX(100%);
        opacity: 0;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        .close-inner{
            position: absolute;
            left: 20px;
            top: 20px;
            cursor: pointer;
        }
        .side-nav-wrap{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 40px;
            li{
                color: #000;
                font-size: 16px;
                line-height: 24px;
                font-weight: 800;
                cursor: pointer;
                &.active{
                    color: #07903a;
                }
            }
        }
    }
    &.active{
        .side-area{
            transform: translateX(0);
            opacity: 1;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        display: block;
    }
`
export default SideNav;